import { useEffect, useState } from 'react';
import {
  ContentInfoAssetResponse,
  GetContentInfoAssetParams,
  getContentInfoForAsset
} from '@smart-tv/utils/kmm/getContentInfoForAsset';

const useProductSheetInfo = ({ sid, eventId, mediaId }: GetContentInfoAssetParams) => {
  const [contentInfoAsset, setContentInfoAsset] = useState<ContentInfoAssetResponse>();
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params: GetContentInfoAssetParams = { sid, eventId, mediaId };
        const data = await getContentInfoForAsset(params);
        setContentInfoAsset(data);
      } catch (err) {
        // this error is custom handled and provides the specific feedback "Kunne ikke indlæse info om programmet" is shown instead
        setError(err);
      }
    };

    fetchData();

    return () => {
      setContentInfoAsset(undefined);
      setError(null);
    };
  }, [sid, eventId, mediaId]);

  return { contentInfoAsset, error };
};

export default useProductSheetInfo;
